import React from "react";
import { Card, Dropdown } from "react-bootstrap";
import { BsThreeDotsVertical } from "react-icons/bs";
import { FaTasks } from "react-icons/fa";

const ProjectCard = ({ project, onEdit, onDelete }) => {
  if (!project || !project.title) return null;

  return (
    <Card className="project-card">
      <Card.Body>
        {/* Header */}
        <div className="card-header-custom">
          <h6 className="title">{project.title}</h6>

          <Dropdown align="end">
            <Dropdown.Toggle className="menu-btn">
              <BsThreeDotsVertical />
            </Dropdown.Toggle>

            <Dropdown.Menu>
              <Dropdown.Item onClick={onEdit}>Edit</Dropdown.Item>
              <Dropdown.Item onClick={onDelete}>Delete</Dropdown.Item>
            </Dropdown.Menu>
          </Dropdown>
        </div>

        {/* Description */}
        <p className="desc">{project.desc}</p>

        <div className="divider" />

        {/* User + Deadline */}
        <div className="user-row">
          <div className="user-info">
            <img src={project.img} alt="" />
            <div>
              <div className="name">{project.user}</div>
              <div className="role">{project.role}</div>
            </div>
          </div>

          <div className="deadline">
            <div className="label">Deadline</div>
            <div className="date">{project.deadline}</div>
          </div>
        </div>

        <div className="divider" />

        {/* Footer */}
        <div className="card-footer-custom">
          <div className="tasks">
            <span className="task-icon">
              <FaTasks />
            </span>
            <span>Tasks : {project.tasks}</span>
          </div>

          <div className="avatars">
            <img src="/assets/img/profiles/avatar-02-1.jpg" alt="" />
            <img src="/assets/img/profiles/avatar-03.jpg" alt="" />
            <img src="/assets/img/profiles/avatar-04.jpg" alt="" />
            <img src="/assets/img/profiles/avatar-02-1.jpg" alt="" />

            <span className="extra">+1</span>
          </div>
        </div>
      </Card.Body>
<style>
     {
          `
          .project-card {
  border-radius: 5px;
  border: 1px solid #e5e7eb;
  box-shadow: 0 2px 6px rgba(0,0,0,0.05);
  padding: 10px;
}

.card-header-custom {
  display: flex;
  justify-content: space-between;
  align-items: center;
}

.title {
  font-size: 15px;
  font-weight: 600;
  margin: 0;
}

.menu-btn {
  background: transparent !important;
  border: none !important;
  padding: 0;
  color: #6b7280;
}

.desc {
  font-size: 13px;
  color: #6b7280;
  margin-top: 8px;
  line-height: 1.5;
}

.divider {
  height: 1px;
  background: #eee;
  margin: 12px 0;
}

.user-row {
  display: flex;
  justify-content: space-between;
  align-items: center;
}

.user-info {
  display: flex;
  align-items: center;
  gap: 10px;
}

.user-info img {
  width: 36px;
  height: 36px;
  border-radius: 50%;
}

.name {
  font-size: 13px;
  font-weight: 600;
}

.role {
  font-size: 12px;
  color: #6b7280;
}

.deadline {
  text-align: right;
}

.deadline .label {
  font-size: 12px;
  color: #6b7280;
}

.deadline .date {
  font-size: 13px;
  font-weight: 500;
}

.card-footer-custom {
  display: flex;
  justify-content: space-between;
  align-items: center;
}

.tasks {
  display: flex;
  align-items: center;
  gap: 6px;
  font-size: 13px;
  color: #374151;
}

.task-icon {
  background: #e6f7ee;
  color: #22c55e;
  border-radius: 50%;
  padding: 6px;
  display: flex;
}

.avatars {
  display: flex;
  align-items: center;
}

.avatars img {
  width: 26px;
  height: 26px;
  border-radius: 50%;
  border: 2px solid #fff;
  margin-left: -8px;
}

.extra {
  background: #f97316;
  color: #fff;
  font-size: 12px;
  padding: 4px 6px;
  border-radius: 50px;
  margin-left: 6px;
}`
     }
</style>

    </Card>
  );
};

export default ProjectCard;